import {ReactComponent as Diagraam} from './diagram.svg'

const Diagram = () => {
     
    return <Diagraam width={25} height={25}/>
}

export default Diagram